import Vue from 'vue';
import Vuex from 'vuex';
import createPersistedState from 'vuex-persistedstate';
import { RootState } from './types';
import { User } from './user';
import { Campaign } from './campaign';
import { Axios } from './axios';

Vue.use(Vuex);

const state: RootState = {
    version: '1.0.0',
} as RootState;

export default new Vuex.Store<RootState>({
    state,
    plugins: [createPersistedState({
        paths: [
          'User',
        ],
    })],
    modules: {
        User,
        Campaign,
        Axios,
    },
    strict: process.env.NODE_ENV !== 'production',
});
